import { createResourceQuery } from '@funtech-int/rival';
import { MovieWebPage, movieWebPageQuery } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { GraphqlClient } from '@/shared/lib/graphqlClient';

interface MovieWebPageQueryVariables {
    contentId: string;
}

interface GQLQueryParams {
    client: GraphqlClient;
    variables: MovieWebPageQueryVariables;
}

export type MovieWebPageResourceQueryResult = MovieWebPage | undefined | null;

export const movieWebPageResourceQuery = createResourceQuery<
    GQLQueryParams,
    MovieWebPage | undefined | null
>({
    key(ctx) {
        return [movieWebPageQuery.name, JSON.stringify(ctx.variables)].join(':');
    },
    fetch() {
        return Promise.resolve(undefined);
    },
    toJSON(data) {
        return data as any;
    },
    hydrate(data: any) {
        return movieWebPageQuery.hydrate(data) as any;
    },
});
